import React from 'react'

export const CustomerListPage = React.lazy(() => import('./list-customer'))
